// extracted by mini-css-extract-plugin
export default {"backButton":"about_backButton__ooyG7","aboutDiv":"about_aboutDiv__hWIiv"};